import API from '..';
const ENTITY = 'products/financier-products';

export const getItems = () => API.get(`/api/v1/${ENTITY}/`);
